import { BsPlusLg, BsDash } from 'react-icons/bs';

interface IQuantityItem {
  id: string;
  handleIncrease: (val: any) => void;
  handleDecrease: (val: any) => void;
  value: any;
  name: string;
}

const QuantityItem = ({
  value,
  name,
  handleIncrease,
  handleDecrease,
}: IQuantityItem) => {
  return (
    <div className="flex flex-row items-center">
      {value > 0 && (
        <div className="h-[30px] w-[30px] flex items-center justify-center">
          <BsDash
            className="border-shadow-4 border-2 rounded-full stroke-1 text-shadow-4"
            fontSize={22}
            onClick={handleDecrease}
          />
        </div>
      )}
      <input
        type="number"
        name={name}
        value={value}
        onChange={() => {}}
        min={0}
        className="font-medium [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none w-8 outline-none text-center text-[20px]"
      />
      <div className="h-[30px] w-[30px] flex items-center justify-center">
        <BsPlusLg
          className="border-secondary border-2 rounded-full stroke-1 text-secondary"
          fontSize={22}
          onClick={e => {
            e.preventDefault();
            handleIncrease(e);
          }}
        />
      </div>
    </div>
  );
};
export default QuantityItem;
